export const projects = [
  {
    id: 1,
    img: "https://tranhuuthang.com/image_resume/sell-chairs.jpg",
    title: "Website Selling chairs ",
    description: `Selling chairs`,
    tags: [
      "Laravel",
      "Vue js",
      "API",
      "Role",
      "Docker",
      "System Window",
      "...",
    ],
    liveLink: "https://www.youtube.com/watch?v=gtB6SraBLE0",
    ghLink: "https://github.com/tranhuuthang2k/ShopEcommerceKatsu",
  },
  {
    id: 2,
    img: "https://tranhuuthang.com/image_resume/shoppet.jpg",
    title: "Website Shoppet Da Nang",
    description: `Pet sale`,
    tags: [
      "React js",
      "Hook",
      "Ant Design",
      "Redux-sagas",
      "Route",
      "redux",
      "reducer",
      "System Window",
      "...",
    ],
    liveLink: "https://shoppets.vercel.app/",
    ghLink: "https://github.com/tranhuuthang2k/reactjs_tutorials",
  },
  {
    id: 3,
    img: "https://tranhuuthang.com/image_resume/corona.png",
    title: "Website Information about covid cases in the word",
    description: `Information about covid cases, use api covid 19 .`,
    tags: [
      "React js",
      "Hooks",
      "Context API",
      "Ant design",
      "System Window",
      "...",
    ],
    liveLink: "https://covid-19-tan-psi.vercel.app/",
    ghLink: "https://github.com/tranhuuthang2k/covid-19",
  },
  {
    id: 5,
    img: "https://tranhuuthang.com/image_resume/movie.png",
    title: "Website Reviews Movies",
    description: `Movie Reviews & ratings in the world`,
    tags: [
      "React js",
      "Hooks",
      "Contex API",
      "Route",
      "Material",
      "System Window",
      "...",
    ],
    liveLink: "https://review-movies-mrkatsu.vercel.app/",
    ghLink: "https://github.com/tranhuuthang2k/movies",
  },
  {
    id: 6,
    img: "https://tranhuuthang.com/image_resume/seafood.png",
    title: "Seafood Mr.Katsu",
    description: `Seafood or seafood in a broad sense, seafood is any marine organism used as food for humans. Seafood includes marine fish, molluscs, crustaceans, and echinoderms. In addition, edible marine plants, such as some seaweeds and microalgae.`,
    tags: [
      "React Native",
      "React Hook",
      "Firebase",
      "Authendicate",
      "Redux-sagas",
      "Onesignal",
      "Navigation",
      "Role",
      "System Window",
      "...",
    ],
    liveLink: "https://play.google.com/store/apps/details?id=com.shopmrkatsu",
    ghLink: "https://github.com/tranhuuthang2k/ReactNative_Shop",
  },

  {
    id: 7,
    img: "https://tranhuuthang.com/image_resume/shopmrkatsu.png",
    title: "Fashion Mr.katsu",
    description: `Mr.Katsu is a brand about Black Liberation, economic and social justice, peace and love.`,
    tags: [
      "Ruby on rails",
      "Jquery Ajax",
      "Mysql",
      "PostgreSql",
      "Handlebar js",
      "Role",
      "System linux",
      "...",
    ],
    liveLink: "https://youtu.be/sK7lh5R3tuI?si=5arp-7S_QVfEnyRG",
    ghLink: "https://github.com/tranhuuthang2k/RubyOnRails_Tutorials",
  },

  {
    id: 8,
    img: "https://tranhuuthang.com/image_resume/rikai-notes.png",
    title: "Rikai Notes",
    description: `Write your notes quickly`,
    tags: [
      "React Js + Ant design",
      "React Hook",
      "Firebase Realtime",
      "System Window",
      "...",
    ],
    liveLink: "https://yournotes-umber.vercel.app/",
    ghLink: "https://github.com/tranhuuthang2k/rikai-notes",
  },
  {
    id: 9,
    img: "https://tranhuuthang.com/image_resume/coding-life.png",
    title: "Coding Life",
    description: `Blogger Coding Life`,
    tags: [
      "Next Js + PWA",
      "Ant design",
      "React Hook",
      "Firebase",
      "System Window",
      "...",
    ],
    liveLink: "https://next-js-life-runs-on-code.vercel.app/",
    ghLink: "https://github.com/tranhuuthang2k/NextJs-Life-Runs-On-Code",
  },
  {
    id: 10,
    img: "https://tranhuuthang.com/image_resume/doimoidayhoc.png",
    title: "Đổi Mới Dạy Học",
    description: `Đổi Mới Dạy Học`,
    tags: [
      "Vue Js + Vite",
      "Element UI Library",
      "Firebase",
      "System Window",
      "...",
    ],
    liveLink: "https://doimoidayhoc.com/",
    ghLink: "https://github.com/tranhuuthang2k/blogger-vuejs",
  },
  {
    id: 11,
    img: "https://tranhuuthang.com/image_resume/tracnghiem.png",
    title: "Tin Học Văn Phòng Quiz Office",
    description: `Quiz Office`,
    tags: [
      "PHP",
      "Material Tailwind",
      "Php My Admin",
      "System Window",
      "...",
    ],
    liveLink: "https://tranhuuthang.com/cee",
    ghLink: "#",
  },
];
